import { NOMINATIONS_RECIEVED, NOMINATIONS_SENT } from "../actions/dashboardActions"

const initialState = {
    sent: 0,
    recieved: 0
}

const dashboardReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case NOMINATIONS_SENT: {
            return { ...state, sent: action.payload }
        }
        case NOMINATIONS_RECIEVED: {
            return { ...state, recieved: action.payload }
        }
        default:
            return state
    }
}
export default dashboardReducer;